import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock } from 'lucide-react';

export default function AdminLogin({ setIsAdmin }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLoginSubmit = (e) => {
    e.preventDefault();
    
    // Hardcoded demo password matching local dev scope
    if (password === 'parlaygg2026') {
      setIsAdmin(true);
      navigate('/dashboard');
    } else {
      setError('Invalid Operational Access Token Credentials.');
    }
  };

  return (
    <div style={{ padding: '6rem 5%', display: 'flex', justifyContent: 'center' }}>
      <div style={{ backgroundColor: '#11160F', border: '1px solid #1B2318', padding: '2.5rem', borderRadius: '8px', width: '100%', maxWidth: '400px' }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <div style={{ display: 'inline-flex', backgroundColor: '#161D13', padding: '1rem', borderRadius: '50%', marginBottom: '1rem', border: '1px solid #1B2318' }}>
            <Lock color="#A3FF12" size={24} />
          </div>
          <h2 className="font-display" style={{ fontSize: '1.5rem' }}>ADMINISTRATION GATEWAY</h2>
          <p style={{ color: '#8E9A88', fontSize: '0.85rem', marginTop: '0.25rem' }}>Enter key token to modify active board slips.</p>
        </div>

        <form onSubmit={handleLoginSubmit}>
          <div style={{ marginBottom: '1.5rem' }}>
            <label style={{ display: 'block', fontSize: '0.8rem', color: '#8E9A88', marginBottom: '0.5rem' }}>System Access Password</label>
            <input 
              type="password" 
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••••••" 
              style={{ width: '100%', backgroundColor: '#080B07', border: '1px solid #1B2318', color: '#fff', padding: '0.75rem', borderRadius: '4px', fontSize: '1rem' }}
              className="glow-border"
            />
          </div>

          {error && <p style={{ color: '#ff4a4a', fontSize: '0.8rem', marginBottom: '1rem' }}>{error}</p>}

          <button type="submit" style={{ width: '100%', backgroundColor: '#A3FF12', color: '#080B07', fontWeight: 700, padding: '0.75rem', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '0.95rem' }}>
            Authenticate Credentials
          </button>
        </form>
      </div>
    </div>
  );
}